module.exports = __webpack_public_path__ + "img/用户头像-女.2a95ebd4.png";